import HeaderContainer from './HeaderContainer';

export default HeaderContainer;